
import SimpleChartBar from "./SimpleChartBar";
import colors from "../../resources/sass/_vars.scss"

const Limits = ({data}) => {
    return (
        <div className="stats-limits">
            <div className="mb-3 d-block">
                <h6>Account Limits</h6>
                <p>You are using: {data?.plan}</p>
            </div>

            <SimpleChartBar title="Audiences" min={data?.audiences?.count} max={data?.audiences?.limit} color={colors.sftp}/>
            <SimpleChartBar title="Leads" min={data?.leads?.count} max={data?.leads?.limit} color={colors.webService}/>
            <SimpleChartBar title="Emails" min={data?.emails?.count} max={data?.emails?.limit} color={colors.email}/>
            <SimpleChartBar title="Sms" min={data?.sms?.count} max={data?.sms?.limit} color={colors.sms}/>
            <SimpleChartBar title="Users" min={data?.users?.count} max={data?.users?.limit} color={colors.users} />
        </div>
    )
}

export default Limits;